import React, { useRef } from 'react';
import styled from 'styled-components';
import DIDAvatar, { DIDAvatarHandle } from '../components/DIDAvatar/DIDAvatar';

const AvatarPage: React.FC = () => {
  const avatarRef = useRef<DIDAvatarHandle>(null);

  const handleTest = async () => {
    if (avatarRef.current) {
      await avatarRef.current.speak('Hola, soy tu asistente virtual de Nacional Monte de Piedad. ¿En qué puedo ayudarte hoy?');
    }
  };

  return (
    <PageContainer>
      <DIDAvatar 
        ref={avatarRef}
        onReady={() => console.log('✅ D-ID Avatar ready')}
        onError={(error) => console.error('❌ D-ID error:', error)}
      />
      <TestButton onClick={handleTest}>
        🎤 Probar Voz
      </TestButton>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
`;

const TestButton = styled.button`
  position: absolute;
  bottom: 30px;
  right: 30px;
  padding: 15px 30px;
  font-size: 16px;
  font-weight: bold;
  color: white;
  background: linear-gradient(135deg, #4CAF50, #45a049);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  box-shadow: 0 5px 15px rgba(76, 175, 80, 0.3);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(76, 175, 80, 0.5);
  }
`;

export default AvatarPage;
